// Detect locale from path or default
export function detectLocale(path) {
  if (path.startsWith('/en/') || path === '/en') {
    return { locale: 'en', cleanPath: path.replace(/^\/en/, '') || '/' };
  }

  if (path.startsWith('/cs/') || path === '/cs') {
    return { locale: 'cs', cleanPath: path.replace(/^\/cs/, '') || '/' };
  }

  if (path.startsWith('/pl/') || path === '/pl') {
    return { locale: 'pl', cleanPath: path.replace(/^\/pl/, '') || '/' };
  }

  // Default to Czech for all other paths
  return { locale: 'cs', cleanPath: path };
}

// Get localized paths for language switching
export function getLocalizedPaths(pageData) {
  const paths = {
    [pageData.locale]: pageData.path
  };

  pageData.localizations?.forEach((loc) => {
    paths[loc.locale] = `/${loc.locale}${loc.path}`;
  });

  return paths;
}
